import { render, staticRenderFns } from "./supplierImg.vue?vue&type=template&id=36e920da&scoped=true"
import script from "./supplierImg.vue?vue&type=script&lang=js"
export * from "./supplierImg.vue?vue&type=script&lang=js"
import style0 from "./supplierImg.vue?vue&type=style&index=0&id=36e920da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e920da",
  null
  
)

export default component.exports